import $ from "/js/libs/jquery-3.3.1.min.js"
import {gsap} from "/js/libs/gsap/all.js"
import {BaseGame} from '/js/app/base/BaseGame.js'
import {Simulator} from '/js/app/components/Simulator.js'
import mqtt from "mqtt";
import {Avatar} from "../components/Avatar";
import {Howl} from "howler";

// Constructor
export class BaseGameLimno extends BaseGame {

  constructor(dataFile, mqttTopicPrefix) {

    // Super constructor
    super(dataFile);
    this.i18n.set("fr");

    // Main HTML Template object
    this.mainNunjuckTemplate = null;
    this.nunjuckEnv = null;

    // Simulator object
    this.simulator = null;

    // MQTT
    this.mqttTopicPrefix = mqttTopicPrefix;
    this.mqttClient = null;

    // Screensaver
    this.stillThereTimeout = false;
    this.initalScreenInterval = false;

    // Wait for all
    this.loadSettings()
      // Load data JSON files
      .then(() => this.loadData())
      // Init nunjucks
      .then(() => this.initNunjucks())
      // Replace strings {{ }}
      .then(() => this.renderNunjucks())
      // Process time consuming elements
      .then(() => Promise.all([
          // Show initial identification screen
          this.showIdentificationScreen(),
          // Init nunjucks
          this.preloadAudio(),
          // MQTT init
          this.initMQTT()
        ])
      )
      // Real game init
      .then(() => this.initGame())
      // Catch errors
      .catch((error) => {
        console.error("error", error)
        $("body").append("<div id='error'>Error: " + error.message + "</div>")
      });
  }

  initMQTT() {
    return new Promise((resolve, reject) => {

      // Init MQTT connection
      this.mqttClient = mqtt.connect(this.settings.mqtt.url, {
        port: this.settings.mqtt.port,
        protocol: this.settings.mqtt.protocol,
        username: this.settings.mqtt.username,
        password: this.settings.mqtt.password,
        clientId: 'tknl_limno_app_' + Math.random().toString(16).substr(2, 8),
      });

      // Subscribe to topics
      this.mqttClient.on("connect", () => {
        console.log("Connected to MQTT broker.")
        this.mqttClient.subscribe(`${this.mqttTopicPrefix}`, (err) => {
          if (err) console.log("Error subscribing.", err.message)
        });
      });

      // Listen to messages
      this.mqttClient.on("message", (topic, message) => {

        // message is Buffer
        const messageString = message.toString();
        // Convert to JSON
        const visitorData = JSON.parse(messageString);

        console.log(topic, visitorData);

        if (visitorData[0].tag === "TD") {
          this.tagDrop(visitorData)
        } else if (visitorData[0].tag === "TR") {
          this.tagRemove()
        }

      });

      resolve();

    });
  }

  tagDrop(visitorData) {
    if (visitorData.length > 0) {
      const event = $.Event('tagDrop');
      event.visitorData = visitorData[0];
      this.currentVisitorData = visitorData[0];
      this.onMessage(event);
    }
  }

  tagUpdateRecord(field, value) {
    this.currentVisitorData.records[field] = value;
  }

  tagSaveCurrentData() {
    this.tagSave(this.currentVisitorData);
  }

  tagSave(visitorData) {
    this.mqttClient.publish(`${this.mqttTopicPrefix}/UPDATE`, JSON.stringify(visitorData));
    console.log("MQTT Publish", `${this.mqttTopicPrefix}/UPDATE`, visitorData);
    this.simulator.loadFromMessage(visitorData);
    this.simulator.saveToLocalStorage();
  }

  sendLedMessage() {
    const visitorData = this.currentVisitorData;
    visitorData.tag = "TRR";
    this.mqttClient.publish(`${this.mqttTopicPrefix}/LED`, JSON.stringify(visitorData));
    console.log("MQTT Publish", `${this.mqttTopicPrefix}/LED`, visitorData);
  }

  tagRemove() {
    const event = $.Event('tagRemove');
    event.visitorData = this.currentVisitorData;
    this.currentVisitorData = null;
    this.onMessage(event);
  }

  currentVisitorHasCompletedRegistration() {
    if (this.currentVisitorData.records["ST_INTRODUCTION"] !== "TRUE") {
      return false;
    }
    const requiredValues = [this.currentVisitorData.records.LANGUAGE, this.currentVisitorData.records.WALLPAPER, this.currentVisitorData.records.EMOTION, this.currentVisitorData.records.AGE]
    for (let i = 0; i < requiredValues.length; i++) {
      if (requiredValues[i] === null || requiredValues[i] === undefined || requiredValues[i] === "" || requiredValues[i] === "FALSE") {
        return false;
      }
    }
    return true;
  }

  // To be overriden in child games
  onMessage(e) {
    const type = e.type;
    const visitorData = e.visitorData;
  }

  // Show identification screen
  showIdentificationScreen() {
    return new Promise((resolve, reject) => {

      // Get duration form settings
      const duration = parseFloat(this.settings["identification_duration"]) * 1000;

      // Prevent identification screen when set to 0 or false
      if (duration === false || duration === 0) return resolve();

      // Animate in and resolve on timeout
      this.goToScreen("onstart-identification");
      setTimeout(() => {
        this.lockScreen = false;
        resolve();
      }, Math.max(duration, 400));
    });
  };

  goToScreen(screenId, callback, skipLockScreenCheck = false) {
    this.stopCurrentNarration();
    return super.goToScreen(screenId, callback, skipLockScreenCheck );
  }

  // To be overridden in child games
  initGame() {
    this.simulator = new Simulator(this.tagDrop.bind(this), this.tagRemove.bind(this));
    this.avatar = new Avatar();
    this.startBurningScreenProtection();
    this.initScreenSaver();
    this.goToScreen(1);

    // Set initial Still There properties
    gsap.set($("#still-there"), {autoAlpha: 0});

    // Remove arduino simulator if requested
    if (typeof this.settings.rfid_simulator != "undefined" && this.settings.rfid_simulator === false) {
      $(".simulator").remove();
    }
  };

  // To be overridden in child games
  initScreen(screenId) {

    // Super constructor
    if (BaseGame.prototype.initScreen.call(this, screenId) === false) {
      return false;
    }

    if (this.requestedLanguage !== false) {
      this.i18n.set(this.requestedLanguage);
      this.requestedLanguage = false;
    }

    switch (screenId) {
      case "onstart-identification":
        return false;
        break;
      case 1:
        this.startBurningScreenProtection();
        break;
      default:
        this.stopBurningScreenProtection();
    }
  }

  playNarration(audioObject, callback = null) {

    this.stopCurrentNarration();

    if (audioObject === undefined) {
      console.log("No audio narration file defined.");
      return;
    }

    const file = audioObject[this.i18n.lang]
    console.log("Play: " + file.replace("audio/logbook/", ""));
    this.sound = new Howl({
      src: [file],
      loop: false,
      autoplay: true,
      // volume: this.settings.volume.ambient_sound,
    });

    if (callback) {
      this.sound.on('end', function () {
        callback();
      });
    }
  }

  stopCurrentNarration() {
    if (this.sound) {
      this.sound.stop();
      this.sound = null;
    }
  }

  // Init visitor preferences
  async initVisitor() {
    if (!(this instanceof Register)) {
      await this.updateNunjucks();
      this.requestedLanguage = (this.currentVisitorData.records.LANGUAGE == "FRA") ? "fr" : "en";
      this.applyTheme(this.currentVisitorData.records.WALLPAPER);
      const repeatDelay = (this instanceof Logbook) ? 20 : 0;
      this.avatar.setAvatar(this.currentVisitorData.records.EMOTION.toLowerCase(), true, repeatDelay);
    } else {
      console.log("Visitor preference is not loaded in Register app, since this app is used to build new data on RFID.")
    }
  }

  // Remove avatar related wallpaper color
  clearTheme(selector = ".themeable") {
    $(selector).removeClass("theme-red theme-blue theme-green");
  }

  // Add avatar related wallpaper color
  applyTheme(theme) {
    this.clearTheme();
    $(".themeable").addClass("theme-" + theme.toLowerCase());
  }

  goToScreenSaver() {

    if ($("#still-there").hasClass("active")) {
      return false;
    }

    $("#still-there").addClass("active");
    this.openStillThereModal();
    this.stillThereTimeout = setTimeout(() => {
      this.reset(1);
      this.closeStillThereModal();
    }, 10000);
  }

  openStillThereModal() {
    var tl = new gsap.timeline();

    tl.to($("#still-there"), 0.5, {
      autoAlpha: 1
    });
    tl.fromTo($("#still-there .modal"), 0.5, {
      autoAlpha: 0,
      y: "-10px",
    }, {
      autoAlpha: 1,
      y: 0,
    });
  }

  startBurningScreenProtection() {
    this.stopBurningScreenProtection();
    const intervalDuration = parseInt(this.settings["burning_screen_interval"]) * 1000;
    this.burningScreenInterval = setInterval(() => {
      console.log("animate BurningScreenProtection")
      gsap.fromTo($("#burning-protect"), 3.5, {
        x: 0,
        ease: "linear"
      }, {
        x: 1920 + 100,
        ease: "linear"
      });
    }, intervalDuration)
  }

  stopBurningScreenProtection() {
    if (this.burningScreenInterval !== false) {
      clearInterval(this.burningScreenInterval);
      this.burningScreenInterval = false;
    }
  }

  closeStillThereModal() {

    if (this.stillThereTimeout != false) {
      clearTimeout(this.stillThereTimeout);
      this.stillThereTimeout = false;
    }

    gsap.to($("#still-there"), 0.5, {
      autoAlpha: 0,
      onComplete: function () {
        $("#still-there").removeClass("active");
      }
    });
  }

  // Reset values when we return to the homepage
  reset(screenId, resetCallback) {

    if (typeof screenId == "undefined") {
      screenId = 1;
    }

    if (BaseGame.prototype.reset.call(this) == false) {
      return false;
    }

    this.stopCurrentNarration();
    this.closeStillThereModal();

    // Return to idle screen
    this.goToScreen(screenId, () => {
      resetCallback();
    }, true);

  }
}
